export enum TEAM_ACTIONS {
  // Members
  /**
   * Add, remove, and manage members
   */
  MEMBERS_MANAGEMENT = 'MEMBERS_MANAGEMENT',
  /**
   * Transfer ownership to another member
   */
  TRANSFER_OWNERSHIP = 'TRANSFER_OWNERSHIP',
  /**
   * Manage roles of members, can't change to owners
   */
  ROLES_MANAGEMENT = 'ROLES_MANAGEMENT',
  // Settings
  /**
   * Manage team settings (names, tiers, etc.)
   */
  SETTINGS_MANAGEMENT = 'SETTINGS_MANAGEMENT',
  /**
   * Delete the team permanently
   */
  DELETE_TEAM = 'DELETE_TEAM',
  // Forms
  /**
   * View forms and responses
   */
  VIEW_FORMS = 'VIEW_FORMS',
  /**
   * Create and edit forms
   */
  CREATE_UPDATE_FORM = 'CREATE_UPDATE_FORM',
  /**
   * Archive forms, removing them from the active list
   */
  ARCHIVE_FORMS = 'ARCHIVE_FORMS',
  /**
   * Close forms, removing them from the active list
   */
  CLOSE_FORMS = 'CLOSE_FORMS',
  /**
   * Delete forms permanently
   */
  DELETE_FORMS = 'DELETE_FORMS',
  /**
   * View responses of forms
   */
  VIEW_RESPONSES = 'VIEW_RESPONSES',
  /**
   * Manage responses of forms
   */
  RESPONSES_MANAGEMENT = 'RESPONSES_MANAGEMENT',
  /**
   * View projects
   */
  VIEW_PROJECTS = 'VIEW_PROJECTS',
  /**
   * Create and edit projects
   */
  CREATE_UPDATE_PROJECTS = 'CREATE_UPDATE_PROJECTS',
  /**
   * Delete projects permanently
   */
  DELETE_PROJECTS = 'DELETE_PROJECTS',
  /**
   * Update teams tier
   */
  UPDATE_TIER = 'UPDATE_TIER',
  /**
   * View project contracts
   */
  VIEW_PROJECT_CONTRACTS = 'VIEW_PROJECT_CONTRACTS',
  /**
   * Create, edit, delete projects contracts
   */
  CREATE_UPDATE_DELETE_PROJECT_CONTRACTS = 'CREATE_UPDATE_DELETE_PROJECT_CONTRACTS',
  /**
   * Create, edit, delete projects contracts
   */
  DEPLOY_PAUSE_PROJECT_PIPELINE = 'DEPLOY_PAUSE_PROJECT_PIPELINE',
  /**
   * View chart page
   */
  VIEW_CHARTS = 'VIEW_CHARTS',
  /**
   * Create, delete, edit charts
   */
  CREATE_DELETE_EDIT_CHARTS = 'CREATE_DELETE_EDIT_CHARTS',
  /**
   * Create, delete, edit project alerts
   */
  CREATE_DELETE_EDIT_PROJECT_ALERTS = 'CREATE_DELETE_EDIT_PROJECT_ALERTS',
  /**
   * View project alerts
   */
  VIEW_PROJECT_ALERTS = 'VIEW_PROJECT_ALERTS',
  /**
   * Import wallet addresses
   */
  IMPORT_WALLET = 'IMPORT_WALLET',
}

export enum TEAM_ROLES {
  /**
   * The creator of the team can only have one
   */
  OWNER = 'OWNER',
  /**
   * Help with managing the team
   */
  ADMIN = 'ADMIN',
  /**
   * Manage forms and submissions
   */
  EDITOR = 'EDITOR',
  /**
   * Can view forms and submissions
   */
  MEMBER = 'MEMBER',
}

export const ROLE_ORDER = {
  [TEAM_ROLES.OWNER]: 0,
  [TEAM_ROLES.ADMIN]: 1,
  [TEAM_ROLES.EDITOR]: 2,
  [TEAM_ROLES.MEMBER]: 3,
};

export const TEAM_PERMISSIONS = {
  // Owners can do everything
  [TEAM_ROLES.OWNER]: Object.values(TEAM_ACTIONS),
  [TEAM_ROLES.ADMIN]: [
    TEAM_ACTIONS.MEMBERS_MANAGEMENT,
    TEAM_ACTIONS.ROLES_MANAGEMENT,
    TEAM_ACTIONS.SETTINGS_MANAGEMENT,
    TEAM_ACTIONS.VIEW_FORMS,
    TEAM_ACTIONS.CREATE_UPDATE_FORM,
    TEAM_ACTIONS.VIEW_PROJECTS,
    TEAM_ACTIONS.CREATE_UPDATE_PROJECTS,
    TEAM_ACTIONS.ARCHIVE_FORMS,
    TEAM_ACTIONS.VIEW_RESPONSES,
    TEAM_ACTIONS.RESPONSES_MANAGEMENT,
    TEAM_ACTIONS.UPDATE_TIER,
    TEAM_ACTIONS.VIEW_PROJECT_CONTRACTS,
    TEAM_ACTIONS.CREATE_UPDATE_DELETE_PROJECT_CONTRACTS,
    TEAM_ACTIONS.DEPLOY_PAUSE_PROJECT_PIPELINE,
    TEAM_ACTIONS.VIEW_CHARTS,
    TEAM_ACTIONS.CREATE_DELETE_EDIT_CHARTS,
    TEAM_ACTIONS.CREATE_DELETE_EDIT_PROJECT_ALERTS,
    TEAM_ACTIONS.VIEW_PROJECT_ALERTS,
    TEAM_ACTIONS.IMPORT_WALLET,
  ],
  [TEAM_ROLES.EDITOR]: [
    TEAM_ACTIONS.VIEW_FORMS,
    TEAM_ACTIONS.VIEW_PROJECTS,
    TEAM_ACTIONS.CREATE_UPDATE_FORM,
    TEAM_ACTIONS.ARCHIVE_FORMS,
    TEAM_ACTIONS.VIEW_RESPONSES,
    TEAM_ACTIONS.VIEW_PROJECT_CONTRACTS,
    TEAM_ACTIONS.CREATE_UPDATE_DELETE_PROJECT_CONTRACTS,
    TEAM_ACTIONS.VIEW_CHARTS,
    TEAM_ACTIONS.CREATE_DELETE_EDIT_CHARTS,
    TEAM_ACTIONS.CREATE_DELETE_EDIT_PROJECT_ALERTS,
    TEAM_ACTIONS.VIEW_PROJECT_ALERTS,
    TEAM_ACTIONS.IMPORT_WALLET,
  ],
  [TEAM_ROLES.MEMBER]: [
    TEAM_ACTIONS.VIEW_FORMS,
    TEAM_ACTIONS.VIEW_PROJECTS,
    TEAM_ACTIONS.VIEW_RESPONSES,
    TEAM_ACTIONS.VIEW_PROJECT_CONTRACTS,
    TEAM_ACTIONS.VIEW_CHARTS,
    TEAM_ACTIONS.VIEW_PROJECT_ALERTS,
  ],
};

export enum TEAM_INVITE_STATUS {
  PENDING = 0,
  ACCEPTED = 1,
  DECLINED = 2,
  EXPIRED = 3,
}

export const TEAM_INVITE_STATUS_MAPPER = [
  'Pending',
  'Accepted',
  'Declined',
  'Expired',
];

export const roles = [
  {
    label: 'Admin',
    value: TEAM_ROLES.ADMIN,
    subtitle: 'Manage workspace settings',
  },
  {
    label: 'Editor',
    value: TEAM_ROLES.EDITOR,
    subtitle: 'Publish and make edits ',
  },
  {
    label: 'Member',
    value: TEAM_ROLES.MEMBER,
    subtitle: 'View projects and forms',
  },
];
